{
  "pt": {
    "profile": {
      "actions": {
        "changeEmail": "Alterar o endereço de e-mail",
        "changeEmailAddress": "Alterar o endereço de e-mail",
        "delete": "Eliminar",
        "installApp": "Instalar a aplicação 🚀",
        "launchApp": "Iniciar a aplicação",
        "save": "Guardar",
        "showQRCode": "Mostrar código QR"
      },
      "attributes": {
        "decimal_separator": "Notação decimal da moeda",
        "email_address": "E-mail",
        "email_address_new": "Novo endereço de e-mail",
        "email_address_old": "Endereço de e-mail antigo"
      },
      "labels": {
        "addToHomeScreen": "Adicionar ao ecrã inicial",
        "allowAccess": "Dar ao Ziggu acesso à sua conta",
        "allowImpersonation": "Permitir o acesso ao Ziggu",
        "allowImpersonationSubtext": "Poderemos ter de aceder temporariamente à sua conta para diagnosticar e resolver um problema de apoio ao cliente que tenha levantado. O nosso acesso expira automaticamente após 7 dias.",
        "allowRecording": "Permitir a gravação da sessão",
        "allowRecordingSubtext": "Gravar a sua sessão no Ziggu pode ajudar-nos a encontrar a causa principal de um problema que tenha levantado. A gravação pára automaticamente após 60 minutos ou sempre que desativar esta definição.",
        "and_x_other": "e 1 outro | e {other_count} outros",
        "bulk_invite_help": "Convidaremos os contactos selecionados para a plataforma. Isto pode demorar alguns minutos.",
        "changeEmailAddress": "Alterar o endereço de e-mail para {profile_name}",
        "checkYourInbox": "Enviámos um e-mail para {email_address} para confirmar",
        "confirmEmailUpdate": "O e-mail contém uma ligação para concluir o processo de atualização. Contacte-nos se tiver algum problema.",
        "confirmPasswordReset": "Foi enviado um e-mail com uma ligação para redefinir a sua palavra-passe. Contacte-nos se tiver algum problema.",
        "currency": {
          "comma": "Vírgula: 200.450,99",
          "point": "Ponto: 200.450,99"
        },
        "emailAddressNewConfirm": "Confirmar o novo endereço de e-mail",
        "emailNotificationsInterval": "Frequência de e-mail para novas notificações",
        "emailNotificationsIntervalSubtext": "Aqui pode definir a frequência com que pretende que a plataforma verifique se existem atualizações para si e lhe envie uma mensagem de e-mail sobre as mesmas.",
        "explainerSendEmail": "Será enviado um novo convite por e-mail para {name}",
        "explainerUpdateEmailActive": "{name} já está ativo na plataforma. Um e-mail será enviado para o novo endereço com uma ligação para confirmar a alteração do endereço de e-mail.",
        "explainerUpdateEmailInvited": "{name} já foi convidado. Será enviado um novo convite para o novo endereço de e-mail. Os convites anteriores deixarão de ser válidos.",
        "followDevicePrompts": "Siga as instruções do seu dispositivo para adicionar a aplicação ao seu ecrã inicial",
        "impersonateProfile": "Fazer-se passar por {profile_name}",
        "important": "Importante",
        "importantContent": "Certifique-se de que tem sessão iniciada na plataforma no seu dispositivo móvel através do navegador Web.",
        "installMobileApp": "Instalar a aplicação móvel",
        "logInMobileDevice": "Iniciar sessão no seu dispositivo móvel",
        "maintainerCannotImpersonatePartner": "Apenas os membros da equipa com a função \"Proprietário\" podem fazer-se passar por parceiros.",
        "maintainerCannotUpdateEmailAddress": "Apenas os membros da equipa com a função \"Proprietário\" podem atualizar o endereço de e-mail",
        "multipleProfiles": "Este utilizador tem vários perfis Ziggu. Apenas o utilizador pode alterar o endereço de e-mail.",
        "mustBeLoggedInBeforeQR": "Tem de ter sessão iniciada no seu dispositivo móvel antes de digitalizar o código QR",
        "noEmailAddressAdded": "Nenhum endereço de e-mail adicionado",
        "onceLoggedInScan": "Uma vez iniciada a sessão, leia o código QR para instalar a aplicação no seu dispositivo",
        "openMobileBrowser": "Abra o seu browser móvel e visite",
        "public_api_access": "Token de acesso à API pública",
        "redirectAutomatically": "Será redirecionado automaticamente em {seconds} segundos",
        "requestPasswordReset": "Repor palavra-passe",
        "scanQRCode": "Digitalizar o código QR",
        "toLogInCredentials": "para iniciar sessão com as suas credenciais",
        "updateEmailFailed": "A atualização do seu endereço de e-mail falhou. Tente novamente ou contacte-nos.",
        "updateEmailSuccessful": "O seu endereço de e-mail foi atualizado com sucesso",
        "updateFailed": "A atualização falhou. Tente novamente ou entre em contacto connosco."
      },
      "notifications": {
        "avatarChangedSuccessfully": "O avatar foi atualizado. As alterações podem demorar até uma hora a ficarem visíveis."
      },
      "toasts": {
        "bulk_invite": "Começámos a convidar os contactos selecionados para a plataforma",
        "emailResendSuccessfully": "Reenvio de e-mail com sucesso"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "O endereço de e-mail não existe ou já não existe. Altere o endereço de e-mail.",
          "illegal_address": "Endereço de e-mail ilegal: o endereço de e-mail que está a fornecer pode não estar configurado corretamente. Certifique-se de que o endereço de e-mail está corretamente formatado e não contém caracteres ilegais.",
          "isp_block": "Bloqueio do ISP: um bloqueio significa normalmente que o nosso endereço IP ou servidor foi rejeitado pelo servidor de correio eletrónico recetor.",
          "soft_bounce": "A pessoa está fora do escritório ou a caixa de correio está cheia e não aceita mensagens de e-mail.",
          "spam_complaint": "A pessoa clicou em \"Marcar como Spam\" no seu cliente de e-mail, este endereço de e-mail foi desativado. Se o destinatário entrar em contacto consigo e quiser voltar a receber mensagens de e-mail, contacte-nos.",
          "spam_notification": "As mensagens de e-mail foram rejeitadas pelo servidor de correio eletrónico. Isto pode dever-se a políticas empresariais rígidas em vigor no servidor de correio eletrónico recetor ou a uma má escolha de palavras no seu e-mail que estão a ser assinaladas pelos filtros de spam."
        },
        "emailAddressBounced": "Erro no endereço de e-mail",
        "emailDoesntMatch": "O e-mail não corresponde",
        "emailTaken": "O endereço de e-mail já está ocupado. Se quiser fazer esta alteração de qualquer forma, contacte-nos através do chat.",
        "mustBeEmailAddress": "É necessário um endereço de e-mail válido",
        "requireEmailAddress": "E-mail necessário",
        "tooManyRequests": "Só é permitida uma alteração de endereço de e-mail a cada 5 minutos. Tente novamente mais tarde."
      }
    }
  }
}
